import { AddItemForm } from "@components/consumer/items";
import withPage from "@components/hoc/withPage";
import { FC } from "react";

const AddItemPage: FC = () => (
    <AddItemForm />
)

export default withPage(AddItemPage);